// src/portal/portalFindingNumber.js
//
// ONE SOURCE FOR A FINDING'S NUMBER.
//
// The mock's README: "Keep the numbering shared — pin n on the map is finding n
// in the list." Two places render that number — the pin badge on the map and
// the pin in the findings list — and a finding renumbered in one and not the
// other is a defect nobody sees until two people are pointing at a map together
// on a phone call.
//
// ── WHY ordinal IS THE NUMBER, AND WHY THAT IS SAFE ────────────────────────
//
// plan_review_markup.ordinal is allocated as max+1 PER REVISION, and route 6
// returns markup for the CURRENT revision only (`where m.revision_id = $1`,
// ordered by ordinal). So within any payload the client ever holds, ordinal is
// 1..n, dense and unique. Numbering by position in an array would be a SECOND
// rule that agrees with it by luck and diverges the first time a caller sorts
// or filters.
//
// This module exists so there is one place to change, and so a mutation to the
// rule moves BOTH renderers at once — which is what makes the numbering a
// demonstrated property rather than a convention.

/**
 * The number shown for a finding, on the map and in the list.
 * @param {{ordinal?: number}} markup
 * @returns {number|null} null when the row carries no ordinal at all
 */
export function findingNumber(markup) {
  const n = markup?.ordinal;
  return Number.isInteger(n) && n > 0 ? n : null;
}

/**
 * The kind, rendered as its LITERAL ENUM VALUE.
 *
 * `setback_violation`, not "Setback violation". That is deliberate in the mock
 * and it is what a reviewer files against: the string in the chip is the string
 * in the record, so quoting one quotes the other. A title-cased label would be
 * a second vocabulary that has to be translated back before it can be used.
 */
export function findingKind(markup) {
  return typeof markup?.markup_type === "string" ? markup.markup_type : null;
}

/** Findings the reviewer has written but not yet sent. Frozen means sent. */
export function stagedFindings(markup = []) {
  return (markup ?? []).filter((m) => !m?.frozen_at);
}
